<wr-new-data-table headerText="Teamsübersicht"
                   localStorageIdentifier="teams-overview"
                   [loadItemsFunction]="loadTeams"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToTeam($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="regionSelect">Bereich</label>
          <wr-region-select id="regionSelect" formControlName="region" [fixedTenantId]="tenantId()"></wr-region-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="team.color"></div>
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="abbreviation"
    display="Kürzel">
    @if (team.abbreviation) {
      <div>
        {{ team.abbreviation }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="name"
    display="Name">
    @if (team.name) {
      <div>
        {{ team.name }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="leader"
    exportKey="leader.fullName"
    display="Leiter*in">
    <wr-user-badge [user]="team.leader"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="region"
    exportKey="region.name"
    display="Bereich">
    @if (team.region) {
      <div>
        {{ team.region.name }}
      </div>
    } @else {
      Kein Bereich
    }
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="totalArea"
    [sortable]="false"
    [exportDecimals]="2"
    display="Gesamte Fläche">
    {{ team.totalArea | number: '1.2-2' }} m²
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="buildingCount"
    [sortable]="false"
    display="Gebäude Anzahl">
      {{ team.buildingCount }}
  </ng-template>
  <ng-template
    dataColumn
    let-team
    key="userCount"
    [sortable]="false"
    display="Benutzer Anzahl">
      {{ team.userCount }}
  </ng-template>
</wr-new-data-table>
